<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <v-card class="mx-auto" max-width="600px">
            <v-toolbar color="secondary" dark>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <Device />
            </v-toolbar>
            <DevicesView />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import DevicesView from "@/components/views/DevicesView";
import Device from "@/components/dialogs/Device";
export default {
  name: "Medications",
  components: {
    DevicesView,
    Device
  },
  events: {
    callToggle() {
      this.toggleComp();
    }
  },
  data: () => ({
    dialog: false,
    valid: true,
    component: DevicesView,
    title: "Your Device(s)",
    btnTitle: "Add"
  }),
  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("user/aAddProfile", this.profile).then(res => {
          if (res) {
            this.dialog = false;
          }
        });
      }
    }
  }
}
</script>

<style>
</style>